import moment from 'moment';
import type { RateMatrix, Promotion } from '../containers/products/products.reducer';
import { Product } from './types';

export const promoProductType = {
  FLAT_RATE: 'Flat rate',
  RATE_VARIANCE: 'Rate variance',
  BONUS: 'Bonus',
} as const;

export const promoCodeSession = {
  PROMO_CODE_PARAM: 'promoCodeParam',
};

export const promoProductFlashMessageDescription = {
  fundByDatePassed:
    'Unfortunately, the fund-by date for this promotion is already past and that offer is no longer available on this product.',
};

export const buildPromoAccountActivityHelperText = (
  promotion: Promotion,
  product: Product
): string => {
  const { promotionMinBalance, promotionType, promotionName } = promotion;
  const { productType } = product;

  if (promotionType === promoProductType.BONUS) {
    return `Promo code applied for ${promotionName} ${productType} Account (Minimum Balance of $${promotionMinBalance} for 90 days)`;
  }

  return '';
};

const commonHelperStatement = (promotionMinBalance) =>
  `A $${promotionMinBalance} minimum opening deposit is required to receive the promotional rate.`;

export const buildPromoFundHelperText = (promotion: Promotion): string => {
  const { promotionMinBalance, promotionType, promotionBonusDays } = promotion;

  switch (promotionType) {
    case promoProductType.BONUS:
      return `You will need to maintain a balance of $${promotionMinBalance} for ${promotionBonusDays} days to receive a cash bonus.`;

    case promoProductType.FLAT_RATE:
      return commonHelperStatement(promotionMinBalance);

    case promoProductType.RATE_VARIANCE:
      return commonHelperStatement(promotionMinBalance);

    default:
      return '';
  }
};

export const isAmountMoreThanOrEqToPromoMinAmount = (amount: number, promotion: Promotion) => {
  return amount >= promotion.promotionMinBalance;
};

export const isFlatRatePromo = (promotion: Promotion) =>
  promotion.promotionType === promoProductType.FLAT_RATE;

export const isVariableRatePromo = (promotion: Promotion) =>
  promotion.promotionType === promoProductType.RATE_VARIANCE;

export const hasPromotionFundByDateNotPassed = (promotionFundByDate: string) => {
  return moment(promotionFundByDate).isSameOrAfter(moment(), 'day');
};

export const hasPromotionEndDateNotPassed = (promotionEndDate: string) => {
  return promotionEndDate ? moment(promotionEndDate).isSameOrAfter(moment(), 'day') : false;
};

export const getApy = (productRateMatrices: Array<RateMatrix>, amount: number) => {
  const rateMatrix = productRateMatrices.find(
    (matrix) => amount >= matrix.minBalance && amount <= matrix.maxBalance
  );

  return rateMatrix ? rateMatrix.apy : null;
};
